import { Switch } from "@headlessui/react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { PropagateLoader } from "react-spinners";
import { toast } from "react-toastify";
import { getApiCaller } from "../../libs/apiCaller";

const Consumer = ({
  isLoading,
  showConsumerList,
  setShowConsumerList,
  getConsumerList,
}) => {
  const navigate = useNavigate(); // Hook to programmatically navigate

  const toggleProviderStatus = async (consumer) => {
    const newStatus = consumer.provider_status === "enable" ? 2 : 1; // 1 = enable, 2 = disable
    const updatedProviders = showConsumerList.map((p) =>
      p.id === consumer?.id
        ? { ...p, provider_status: newStatus === 1 ? "enable" : "disable" }
        : p
    );

    try {
      const response = await getApiCaller(
        `provider_status_change?provider_id=${consumer?.id}&status=${newStatus}`
      );
      if (response?.data?.response_code === 200) {
        setShowConsumerList(updatedProviders); // Update state to reflect change
        toast.success(response?.data?.response_message);
      }
      getConsumerList && getConsumerList();
    } catch (error) {
      toast.error("Failed to update provider status.");
    }
  };

  return (
    <>
      <div className="overflow-x-auto">
        <table className="w-full border border-1 rounded-xl min-w-[800px]">
          <thead className="bg-gray-50  rounded-t-xl">
            <tr>
              <th className="py-3 px-4 text-left text-sm tracking-wide text-[#60646C]">
                No.
              </th>
              <th className="py-3 px-4 text-left text-sm tracking-wide text-[#60646C]">
                <div className="flex items-center gap-1">Consumer Name</div>
              </th>
              <th className="py-3 px-4 text-left text-sm tracking-wide text-[#60646C]">
                <div className="flex items-center gap-1">
                  Appointments Booked
                </div>
              </th>
              <th className="py-3 px-4 text-left text-sm tracking-wide text-[#60646C]">
                <div className="flex items-center gap-1">
                  Appointments cancelled
                </div>
              </th>
              <th className="py-3 px-4 text-left text-sm tracking-wide text-[#60646C]">
                <div className="flex items-center gap-1">Joined Date</div>
              </th>
              <th className="py-3 px-4 text-left text-sm tracking-wide text-[#60646C]">
                <div className="flex items-center gap-1">Patients</div>
              </th>
              <th className="py-3 px-4 text-left text-sm tracking-wide text-[#60646C]">
                Disable Consumer
              </th>
              <th className="py-3 px-4 text-left text-sm tracking-wide text-[#60646C]">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan="7" className="pt-5 pb-7 justify-items-center">
                  <PropagateLoader color="#284184" loading={true} size={10} />
                </td>
              </tr>
            ) : showConsumerList?.length === 0 ? (
              <tr>
                <td
                  colSpan="7"
                  className="pt-5 pb-7 justify-items-center text-center"
                >
                  No Consumers Found...
                </td>
              </tr>
            ) : (
              showConsumerList?.map((consumer) => (
                <tr key={consumer.id} className="border-b hover:bg-gray-50">
                  <td className="py-4 px-4 text-base">{consumer.id}</td>
                  <td className="py-4 px-4 text-base">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center">
                        <img
                          src={
                            consumer.profile_picture ||
                            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTqafzhnwwYzuOTjTlaYMeQ7hxQLy_Wq8dnQg&s"
                          }
                          alt={consumer.name}
                          className="w-10 h-10 rounded-full"
                        />
                      </div>
                      {consumer.first_name} {consumer.last_name}
                    </div>
                  </td>
                  <td className="py-4 px-4 text-base">
                    {consumer.appointment_booked}
                  </td>
                  <td className="py-4 px-4 text-base">
                    {consumer.appointment_cancelled}
                  </td>
                  <td className="py-4 px-4 text-base">
                    {consumer.joined_date.split(" ")[0]}
                  </td>
                  <td className="py-4 px-4 text-base">{consumer.patients}</td>
                  <td className="py-4 px-4">
                    <Switch
                      checked={consumer?.provider_status === "enable"}
                      onChange={() => toggleProviderStatus(consumer)}
                      className={`group inline-flex h-6 w-11 items-center rounded-full transition ${
                        consumer?.provider_status !== "enable"
                          ? "bg-[#284184]"
                          : "bg-gray-200"
                      }`}
                    >
                      <span
                        className={`size-4 translate-x-1 rounded-full bg-white transition ${
                          consumer?.provider_status !== "enable"
                            ? "translate-x-6"
                            : ""
                        }`}
                      />
                    </Switch>
                  </td>
                  <td className="py-4 px-4 text-base">
                    <button
                      className="text-[#284184] underline"
                      onClick={() =>
                        navigate(`/consumerProfile/${consumer.id}`)
                      }
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Consumer;
